const OutstandingInfo = () => <h1>Outstanding info</h1>

export default OutstandingInfo
